import React, { useEffect, useState } from "react";
import { TagPicker } from "rsuite";
import 'rsuite/dist/rsuite.min.css';

const TagInput = ({
    defaultValue = [],
    predefinedTags = [],
    setFormData,
    label,
    type
}) => {
    const [data, setData] = useState([]);

    useEffect(() => {
        const allTags = Array.from(new Set([
            ...predefinedTags,
            ...defaultValue
        ]));

        setData(allTags);
    }, [defaultValue, predefinedTags]);

    const handleChange = (value) => {
        setFormData(prev => ({
            ...prev,
            [type]: value
        }));

        const newTags = value.filter(val => !data.includes(val));
        if (newTags.length > 0) {
            setData(prev => [...prev, ...newTags]);
        }
    };

    return (
        <div className="mt-2">
            {label && <label className="form-label small mb-1">{label}</label>}
            <TagPicker
                data={data.map(tag => ({ label: tag, value: tag }))}
                value={defaultValue}
                onChange={handleChange}
                placeholder={`Add ${type}...`}
                style={{ width: '100%' }}
                creatable
                cleanable={false}
            />
        </div>
    );
};

export default TagInput;
